import Vue from "vue";
import VueI18n from "vue-i18n";
import content from "./data/content.json";
import getLocale from "./helpers/getLocale";
import formatPrice from "./helpers/formatPrice";
import App from "./App.vue";
import router from "./router";

const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);

Vue.config.productionTip = false;

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: getLocale(),
  messages: content,
});

Vue.filter("formatPrice", formatPrice);

new Vue({
  i18n,
  router,
  render: (h) => h(App),
}).$mount("#estimate-calculator-vue-app");
